import React, { FC } from 'react'

const MusicContributorAgreement: FC<{ headerHeight: string }> = ({ headerHeight }) => {
  React.useEffect(() => {
    document.title = 'Music Contributor Agreement'
  }, [])

  return (
    <iframe
      style={{ height: 'calc(100vh - ' + headerHeight + ')' }}
      src="/static/pdf/Arpeggi - Music Contributor Agreement (8.31).pdf"
    />
  )
}

export default MusicContributorAgreement
